import type { PricingQuoteResponse, ProductCard } from "@itaas/pep-contracts";
import type { PepLocale } from "../../i18n/types";
import { ProductDetailHdPage } from "./ProductDetailHdPage";
import { RH_HD_CONFIG } from "./rh-detail-content";

export interface RhProductDetailHdProps {
  locale: PepLocale;
  product: ProductCard & { complementary?: ProductCard[] };
  prices: Record<string, PricingQuoteResponse>;
  description: string;
  showDemo: boolean;
  showTrial: boolean;
}

/** RH HD page — same shared layout as Edu, RH content + assets via config. */
export function RhProductDetailHd(props: RhProductDetailHdProps) {
  return <ProductDetailHdPage {...props} config={RH_HD_CONFIG} />;
}
